module.exports = __webpack_public_path__ + "img/img5525_comp.b3079360.jpg";